<template>
    <!-- custom filter scenario 6 -->
    <!-- customer filter (admin only) & MP filter & custom date & radius filter & latitude & longitude filter -->

    <div class="custom-filter-container-s6">
        <!-- Custom filter -->
        <el-row :span="24">
            <div 
            class="custom-filter-container-wrapper filter-s6-container-wrapper row y-center m-0 mt-2 mb-12 py-2 pl-2 bg-me-primary rounded-4 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form w-100-p">
                <el-space
                    class="custom-filter-space"
                    fill
                    >

                    <el-row gutter="20">
                        <!-- customer filter -->
                        <el-col
                        v-if="
                            $store.state.auth.user != null &&
                            $store.state.auth.user.is_admin
                        "
                        
                        >
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="customer"
                                label="Customer"
                            >
                                <!-- customer select -->
                                <div >
                                    <el-select 
                                        v-model="filter.customer_id" 
                                        placeholder="Select Customer"  
                                        class="custom-filter-select"
                                        clearable
                                        >
                                        <el-option
                                            v-for="item in customers"
                                            :key="item.id"
                                            :label="item.full_name"
                                            :value="item.id"
                                            >
                                            <span>{{ item.full_name }}</span>
                                            <!-- <span>{{ item.phone }}</span> -->
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                        <!-- MP filter -->
                        <el-col>
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="mp"
                                label="Monitoring Period"
                            >
                                <!-- MP dropdown -->
                                <div>
                                    <el-select 
                                        v-model="selectedMonitorPeriod.name"
                                        placeholder="Select Monitoring Period" 
                                        class="custom-filter-select"
                                        >
                                        <el-option
                                        v-for="(item, index) in monitoringPeriods"
                                        :key="index"
                                        :label="item.id"
                                        :value="item.id"
                                        @click="handleSelectedMP(item.name, item.id, item.start_date, item.end_date)"
                                        >
                                            <span>
                                                {{  item.name == null ? item.status_display : item.name }}
                                            </span>
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 7 days" value="Last 7 days" @click="handleSelectedMPName('Last 7 days')">
                                            Last 7 days
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 30 days" value="Last 30 days" @click="handleSelectedMPName('Last 30 days')">
                                            Last 30 days
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 12 months" value="Last 12 months" @click="handleSelectedMPName('Last 12 months')">
                                            Last 12 months
                                        </el-option>
                                        <el-option label="Custom Date" value="custom" @click="displayCustomDate = true">
                                            Custom Date
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>

                        <!-- custom date filter -->
                        <el-col >
                            <el-tooltip
                                    effect="light"
                                    placement="top"
                                    show-after="500"
                                    hide-after="300"
                                    >
                                    <template #content > 
                                        <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select custom date from monitoring period to enable editing" }} </span>
                                    </template>
                            <el-form-item
                                class="custom-filter-item"
                                prop="datetime"
                                label="Datetime"
                            >
                                <!-- date range picker -->
                                <div>

                                    <el-date-picker
                                        class="custom-filter-date-picker"
                                        v-model="dateTimeRange"
                                        type="datetimerange"
                                        :disabled-date="disableAuditorCustomDate"
                                        start-placeholder="Start date"
                                        end-placeholder="End date"
                                        range-separator="To"
                                        format="DD/MM/YYYY HH:mm:ss"
                                        value-format="YYYY-MM-DD HH:mm:ss"
                                        unlink-panels
                                        :disabled="!displayCustomDate"
                                        @change="handleDateRangeChange"
                                    >
                                        <template #prev-month>
                                        <el-icon><CaretLeft /></el-icon>
                                        </template>
                                        <template #next-month>
                                        <el-icon><CaretRight /></el-icon>
                                        </template>
                                        <template #prev-year>
                                        <el-icon>
                                            <svg
                                            viewBox="0 0 20 20"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            >
                                            <g stroke-width="1" fill-rule="evenodd">
                                                <g fill="currentColor">
                                                <path
                                                    d="M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z"
                                                />
                                                </g>
                                            </g>
                                            </svg>
                                        </el-icon>
                                        </template>
                                        <template #next-year>
                                        <el-icon>
                                            <svg
                                            viewBox="0 0 20 20"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            >
                                            <g stroke-width="1" fill-rule="evenodd">
                                                <g fill="currentColor">
                                                <path
                                                    d="M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z"
                                                />
                                                </g>
                                            </g>
                                            </svg>
                                        </el-icon>
                                        </template>
                                    </el-date-picker>
                                    
  
                                </div>
                            </el-form-item>
                        </el-tooltip>
                        </el-col>  

                        <!-- latitude and longitude filter -->
                        <el-col>
                            
                            <el-form-item class="custom-filter-item" label="Latitude">
                                <div >
                                    <el-input 
                                    type="number" 
                                    v-model="Latitude" 
                                    class="filter-drop height-40" 
                                    controls-position="right" 
                                    />
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item class="custom-filter-item" label="Longitude">
                                <div >
                                    <el-input 
                                    type="number" 
                                    v-model="Longitude" 
                                    class="filter-drop  height-40" 
                                    controls-position="right"
                                    />
                                </div>
                            </el-form-item>
                        </el-col>

                        <!-- radius filter -->
                        <el-col>
                            <el-form-item class="custom-filter-item" label="Radius">
                                <div>
                                    <el-input
                                    v-model="radius"
                                    placeholder="Please input radius"
                                    type="number"
                                    :min="0"
                                    class="input-with-select"
                                    >
                                    <template #prepend>
                                        <el-select v-model="unit" placeholder="Select Unit" style="width: 115px">
                                        <el-option label="Kilometers" value="kms" />
                                        <el-option label="Miles" value="miles" />
                                        </el-select>
                                    </template>
                                </el-input>
                                </div>

                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-space>
                </el-form>
                <el-row gutter="20" class="custom-filter-button-container float-right mb-20">
                    <el-button
                        @click="applyFilter"
                        class="custom-filter-button-apply"
                    >
                        <svg class="width-111 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                        </svg>
                    </el-button>
                    <el-button
                        @click="resetFilter"
                        class="custom-filter-button-reset"
                    >
                        <svg class="width-112 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                        </svg>
                    </el-button>
                </el-row>
            </div>
        </el-row>
    </div>
</template>

<script>
import moment from "moment";
import UserService from "../../../services/user.service";
import { shorterLabel, isAuditorUser, customersForAccess, monitoringPeriodsForAccess, monitoringPeriodDateBounds, monitoringPeriodRangePickerValue, isDateOutsideMonitoringPeriodBounds } from "./common-tools";

export default {
    props: {
        periodNameProp: {
            type: String,
            default: "All",
        },
    },
    data() {
        return {
            displayFilter: false, // toggle display of custom filter
            displayCustomDate: false,
            applyMPs: true,
            customers: [],
            dateTimeRange: [null, null],
            loading: false,
            options: [], // for location and MP dropdowns
            list: [], // backup list for filtering
            filter: {
                customer_id: null,
                startDate: null,
                endDate: null,
            },

            hasMPData: true, // control if show MP filter tab, if no data in MP database, use 12 months as MP and hide MP tab buttons

            selectedPeriod: this.periodNameProp,

            optionName: '',
            isAdding: false,

            // Monitoring Periods DATA
            monitoringPeriods: [],

            // data for Monitoring Periods filter button
            selectedMonitorPeriod: {
                id: null,
                name: "current",
                dateTimeRange: [null, null],
            },

            Latitude: 0,
            Longitude: 0,
            radius: 0,
            unit: "kms",
        }
    },
    watch: {
        selectedPeriod: {
        handler: function (newValue) {
            this.customDate = false;
            let date = this.dateCalc(newValue);
            this.filter.startDate = date.start_date;
            this.filter.endDate = date.end_date;
            this.dateTimeRange = [date.start_date, date.end_date];
        },
        deep: true,
        },

        'selectedMonitorPeriod.name': {
            handler: function (newValue) {
                if(newValue == "custom") {
                    this.displayCustomDate = true;
                    this.filter.mp_id = null;
                } else {
                    this.displayCustomDate = false;

                    if(newValue == "Last 12 months" || newValue == "Last 30 days" || newValue == "Last 7 days") {
                    this.filter.mp_id = null;
                    this.selectedMonitorPeriod.id = newValue;
                    this.customDate = false;
                    let date = this.dateCalc(newValue);
                    this.filter.startDate = date.start_date + " 00:00:00";
                    this.filter.endDate = date.end_date + " 23:59:59";
                    this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                }
                }
            },
            deep: true,
        },


        'filter.customer_id': function (newValue) {
            // Convert empty string to null when customer is cleared
            if (newValue === '') {
                this.filter.customer_id = null;
            }
        },
    },

    async mounted() {
        // this.selectedPeriod =
        if (
            this.$store.state.auth.user != null &&
            this.$store.state.auth.user.is_admin
        ) {
            this.fetchCustomerData();
        }

        if (this.applyMPs) {

            await this.fetchMonitoringPeriods();

        } else if (this.periodNameProp == "2023 MP") {
            let date = this.dateCalc(this.periodNameProp);
            this.filter.startDate = date.start_date;
            this.filter.endDate = date.end_date;
            this.dateTimeRange = [date.start_date, date.end_date];
        }

        this.applyFilter();
    },

    methods: {
        // change label to shorter label for fixed button length
        shortLabel(inputLabel,length,MaxLength,additional) {
        let label = shorterLabel(inputLabel,length,MaxLength,additional);
        return label;
        },

        disableAuditorCustomDate(date) {
            if (!this.isAuditor) {
                return false;
            }
            return isDateOutsideMonitoringPeriodBounds(date, monitoringPeriodDateBounds(this.monitoringPeriods));
        },

        isAuditorDateRangeInvalid(value) {
            if (!this.isAuditor || !value || value.length !== 2) {
                return false;
            }
            const bounds = monitoringPeriodDateBounds(this.monitoringPeriods);
            return [value[0], value[1]].some((date) => isDateOutsideMonitoringPeriodBounds(date, bounds));
        },

        handleDateRangeChange(value) {
            const hasRange = value && value.length === 2 && value[0] && value[1];
            if (this.isAuditor && !hasRange) {
                this.resetCustomDateToAvailableRange();
                return;
            }
            if (this.isAuditorDateRangeInvalid(value)) {
                this.$message.warning("Custom date must stay within the available monitoring periods.");
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                return;
            }
            if (hasRange) {
                this.filter.startDate = value[0];
                this.filter.endDate = value[1];
            } else {
                this.filter.startDate = null;
                this.filter.endDate = null;
            }
        },

        resetCustomDateToAvailableRange() {
            const range = monitoringPeriodRangePickerValue(this.monitoringPeriods);
            if (!range) {
                this.$message.warning("Custom date must stay within the available monitoring periods.");
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                return;
            }
            this.filter.startDate = range[0];
            this.filter.endDate = range[1];
            this.$nextTick(() => {
                this.dateTimeRange = [range[0], range[1]];
            });
        },

        keepAuditorCustomDate() {
            if (!this.isAuditor || this.selectedMonitorPeriod.name !== "custom") {
                return true;
            }
            if (this.filter.startDate && this.filter.endDate) {
                return true;
            }
            this.resetCustomDateToAvailableRange();
            return Boolean(this.filter.startDate && this.filter.endDate);
        },

        async fetchCustomerData() {
            this.loading = true;
            await UserService.getCustomers(null)
                .then(
                (response) => {
                    if (!response || !response.data || !response.data.customers) {
                        this.customers = [];
                    } else {
                        this.customers = customersForAccess(response.data.customers, this.$store.state.auth.user);
                    }
                },
                (error) => {
                    this.loading = false;
                    console.log(error.message);
                    if (error.response.status == 401) {
                    this.$router.push({
                        path: "/",
                    });
                    }
                }
                )
                .catch((error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response.status == 401) {
                    this.$router.push({
                    path: "/",
                    });
                }
                })
                .finally(() => (this.loading = false));
        },

        handleSelectedMPName(name) {
            this.selectedMonitorPeriod.name = name;
        },

        async fetchMonitoringPeriods() {
            const parseAndSetMonitoringPeriod = (mp) => {
                this.selectedMonitorPeriod.name = mp.name;
                this.selectedMonitorPeriod.id = mp.id;
                this.filter.startDate = mp.start_date.replace("T", " ");
                this.filter.endDate = mp.end_date.replace("T", " ");
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
            };

            const findLatestMP = (list, status) => {
                const filtered = list.filter(mp => mp.status === status);
                if (filtered.length > 0) {
                return filtered.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
                }
                return null;
            };

            const fallbackToFirst = async (monitoringPeriods) => {
                console.log("Both Current and Under audit Monitoring Period not found.");
                
                const fallback = monitoringPeriods[0];
                console.log("Fallback to first MP: ", fallback.name, fallback.start_date, fallback.end_date);
                parseAndSetMonitoringPeriod(fallback);
            };

            const handleMPSelection = async (monitoringPeriods) => {
                monitoringPeriods = monitoringPeriodsForAccess(monitoringPeriods, this.$store.state.auth.user);
                this.monitoringPeriods = monitoringPeriods;

                // 1. Try "current"
                let mp = findLatestMP(this.monitoringPeriods, "current");

                // 2. If not found, try "under_audit"
                if (!mp) {
                mp = findLatestMP(this.monitoringPeriods, "under_audit");
                }

                if (mp) {
                console.log("Selected MP: ", mp.name, mp.start_date, mp.end_date);
                parseAndSetMonitoringPeriod(mp);
                } else if (monitoringPeriods.length > 0) {
                await fallbackToFirst(this.monitoringPeriods);
                }
            };

            // Start: Try from sessionStorage first
            const cached = sessionStorage.getItem("monitoringPeriods");
            if (cached) {
                try {
                const parsed = JSON.parse(cached);
                await handleMPSelection(parsed);
                return;
                } catch (err) {
                console.error("Error parsing sessionStorage monitoringPeriods");
                console.log("no monitoring periods in session data, fetching monitoring periods...");
                }
            }

            // Fetch from API if no session data
            try {
                const response = await UserService.getMonitoringPeriods(null, "", 1, 50, true);
                const data = response.data.monitoring_periods || [];

                if (data.length > 0) {
                sessionStorage.setItem("monitoringPeriods", JSON.stringify(data));
                await handleMPSelection(data);
                } else {
                // no data in MP database, set selected mp name to '12 months'
                console.log('Monitoring periods data is empty, use 12 months instead');
                this.hasMPData = false;
                this.selectedMonitorPeriod.name = 'Year';
                this.loading = false;
                return;
                }
            } catch (error) {
                this.loading = false;
                console.error("Monitoring periods fetch error:", error.message);
                if (error.response?.status === 401) {
                this.$router.push({ path: "/" });
                }
            } finally {
                this.loading = false;
            }
        },

        handleSelectedMP(name, id, start_date, end_date) {
            this.selectedMonitorPeriod.name = name;
            this.selectedMonitorPeriod.id = id;
            this.selectedMonitorPeriod.start_date = start_date.replace("T", " ");
            this.selectedMonitorPeriod.end_date = end_date.replace("T", " ");
            this.filter.startDate = start_date.replace("T", " ");
            this.filter.endDate = end_date.replace("T", " ");
            this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
        },

        onAddOption() {
            this.isAdding = true
        },

        onConfirm() {
        if (this.optionName) {
            this.monitoringPeriods.push({
            label: this.optionName,
            value: this.optionName,
            })
            this.clear()
        }
        },

        clear() {
            this.optionName = ''
            this.isAdding = false
        },

        dateCalc(period) {
            let current = moment().format("yyyy-MM-DD");
            if (period == "Today") {
                return {
                start_date: current,
                end_date: current,
                };
            } else if (period == "Last 7 days") {
                return {
                start_date: moment(current).subtract(1, "w").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "Last 30 days") {
                return {
                start_date: moment(current).subtract(1, "M").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "Last 12 months") {
                return {
                start_date: moment(current).subtract(1, "y").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "All") {
                return {
                start_date: null,
                end_date: null,
                };
            }
        },

        applyFilter() {
            if (!this.keepAuditorCustomDate()) {
                return;
            }
            this.displayCustomDate = false;
            
            let filter = {
                customer_id: this.filter.customer_id === '' ? null : this.filter.customer_id,
                lat: this.Latitude ? Number(this.Latitude) : 0,
                lng: this.Longitude ? Number(this.Longitude) : 0,
                radius: this.radius ? Number(this.radius) : 0,
                unit: this.unit,
                start_date: this.filter.startDate,
                end_date: this.filter.endDate,
            }
            // console.log("this.filter s6", filter);
            if(this.selectedMonitorPeriod.name != "custom") {
                this.displayCustomDate = false;
            } else {
                this.displayCustomDate = true;
            }
            this.$emit("filterHandle", filter);
        },

        async resetFilter() {
            this.Latitude = 0;
            this.Longitude = 0;
            this.radius = 0;
            this.unit = "kms";

            this.filter = {
                customer_id: null,
                startDate: null,
                endDate: null,
            };
            this.dateTimeRange = [null, null];

            await this.fetchMonitoringPeriods();
            // this.$emit("filterHandle", this.filter);
        },


    },

    computed: {
        isAuditor() {
            return isAuditorUser(this.$store.state.auth.user);
        },
        dayMonthYear() {
            return [
                { text: 'Last 7 days', value: [moment().subtract(7, 'days').toDate(), new Date()] },
                { text: 'Last 30 days', value: [moment().subtract(30, 'days').toDate(), new Date()] },
                { text: 'Last 12 months', value: [moment().subtract(12, 'months').toDate(), new Date()] },
            ];
        },
    },
}
</script>

